import { Component, OnInit ,Output, EventEmitter, HostListener } from '@angular/core';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { Router , ActivatedRoute } from '@angular/router';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { browserRefresh } from 'src/app/app.component';
@Component({
  selector: 'app-side-bar-menu',
  templateUrl: './side-bar-menu.component.html',
  styleUrls: ['./side-bar-menu.component.css']
})
export class SideBarMenuComponent implements OnInit {

  @Output() sidebarshowevent = new EventEmitter();
  isSidebarOpen = false;  // Sidebar open/close for mobile view
  isCollapsed = false;

    // Declare height and width variables
scrHeight:any;
scrWidth:any;


  currentUser:User;
  username;
  branch;
role;
branchs;
error;
nameInitials;
sidebarshow=true;
years;
loggedInUserId;
menuItems=[];
settingItems=[];
  constructor(private router: Router,
    private _authenticationService: AuthenticationService,
    private _appointment: AppointmentService,
    private actroute: ActivatedRoute) {
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
      this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
      this.branch=this.currentUser.branch;
      this.role=this.currentUser.role;
      this.loggedInUserId=this.currentUser.userName;
      console.log(this.role);
        //Getting Name initials
    const fullName = this.username.split(' ');
    this.nameInitials= fullName.shift().charAt(0) + fullName.pop().charAt(0);
     }

     this.getAllYears();
     this.getScreenSize();
    }

  ngOnInit(): void {
    this.getAllYears();
    this.getAllBranchs();
  }


  getAllYears(){
    this._appointment.getAllYears().subscribe(
      (res) => {
  
        this.years = res;
       // console.log(res);
      },
      (err) => {
        this.error = err;
      }
    );
  }


  fullreportdashboard(year){
//console.log(year);
this.router.navigate(['../report-dashboard',{extra:year}],{relativeTo:this.actroute});
  }


  branchreportdashboard(year){
  //  console.log(year);
    this.router.navigate(['../branch-report',{extra:year}],{relativeTo:this.actroute});
      }


  onShowDetails() {
    this.sidebarshow = !this.sidebarshow
    this.sidebarshowevent.emit(this.sidebarshow)
 /**if(this.sidebarshow){
      document.getElementById('hamburger').hidden;
     
    }else{
      document.getElementById('cross').hidden;
    }*/
    
}


  getAllBranchs(){
    this._appointment.getAllBranchs().subscribe(
      (res) => {

        this.branchs = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }

  changeBranch(branch){
    this.branch=branch;
    localStorage.setItem('currentUser.branch', JSON.stringify(branch));
    
//this._authenticationService.currentUser.
  }



  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
        this.scrHeight = window.innerHeight;
        this.scrWidth = window.innerWidth;
       // console.log(this.scrHeight, this.scrWidth);
  }
    toggleSubMenu(item: any) {
      // Toggle only the clicked item's submenu
      item.hasSubMenu = !item.hasSubMenu;
    }
    toggleSidebar() {
  
      if (this.isMobileView()) {
        // Toggle open/close on mobile
        this.isSidebarOpen = !this.isSidebarOpen;
      } else {
        // Toggle collapse in desktop view
        this.isCollapsed = !this.isCollapsed;
      }
      console.log('isCollapsed:', this.isCollapsed, 'isSidebarOpen:', this.isSidebarOpen);
    }
  


// Detect window resize to handle mobile view
isMobileView(): boolean {
  return window.innerWidth < 768; // Adjust based on your breakpoint
}

  logout() {
    this._authenticationService.logout(this.loggedInUserId);
    this.router.navigate(['/login']);
}

isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

isReceptionist() {
  return this.currentUser && this.currentUser.role === UserRole.Receptionist;
}

isSalesRep() {
  return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
}

isPowerUser() {
  return this.currentUser && this.currentUser.role === UserRole.PowerUser;
}

isSalesSupport() {
  return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
}

isSuperUser() {
  return this.currentUser && this.currentUser.role === UserRole.SuperUser;
}

isShipper() {
  return this.currentUser && this.currentUser.role === UserRole.Shipper;
}


is1020Lawrence() {
  return this.currentUser && this.currentUser.branch === "1020 Lawrence";
}

isOntario(){
  return this.currentUser && (this.currentUser.branch === "1020 Lawrence" || this.currentUser.branch === "8899 Jane St" || this.currentUser.branch === "3050 Vega");
}

}
